type SnowflakeIconProps = {
  color?: string;
  size?: string;
}

export const SnowflakeIcon = ({ color, size }: SnowflakeIconProps): JSX.Element => (
  <svg width={size ?? '24'} height={size ?? '24'} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.7732 9.2L7.22675 14.8M16.7732 9.2L17.6378 5.92154M16.7732 9.2L20 10.0785M7.22675 14.8L4 13.9215M7.22675 14.8L6.36214 18.0785M16.7732 14.7999L7.22668 9.19988M16.7732 14.7999L20 13.9214M16.7732 14.7999L17.6379 18.0784M7.22668 9.19988L6.36226 5.92163M7.22668 9.19988L4.00011 10.0785M12 6.4L12 17.6M12 6.4L9.63785 4M12 6.4L14.3621 4M12 17.6L9.63785 20M12 17.6L14.3621 20" stroke={color ?? 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
